var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ mobile: _vm.$mq === 'sm' },attrs:{"id":"misc-legal"}},[_c('router-link',{attrs:{"to":"/imprint"}},[_vm._v("Impressum")]),_c('span',[_vm._v("|")]),_c('router-link',{attrs:{"to":"/terms-and-conditions"}},[_vm._v("AGB")]),_c('span',[_vm._v("|")]),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Datenschutz")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }